import styled from "styled-components";
import { FormWrapper } from "../../styles/BooksAddFunds.style";

// The widget below is not a FormWrapper child, so its 30px gap never
// separates it from the balance card; this padding does.
export const BalanceSection = styled(FormWrapper)`
  padding-bottom: 15px;
`;

export const RecentDeposits = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 15px 20px;

  ${({ theme }) => theme.xs`
    padding: 10px 0 20px;
  `}
`;

export const RecentTitle = styled.h4`
  margin: 0 0 4px;
  font-size: 14px;
  color: ${({ theme }) => theme.textMuted};
`;

export const DepositRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid ${({ theme }) => theme.divider};
  font-size: 13px;

  &:last-child {
    border-bottom: none;
  }
`;

export const RowAmount = styled.span`
  font-weight: 600;
  white-space: nowrap;
`;

export const RowDate = styled.span`
  color: ${({ theme }) => theme.textMuted};
`;

export const RowTx = styled.a`
  font-family: monospace;
  color: ${({ theme }) => theme.primary};
`;

export const EmptyNote = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.textMuted};
`;
